import { OrderStatus } from 'src/types/enums';

const CREATE_LINE_STATUSES = [OrderStatus.Draft, OrderStatus.Created, OrderStatus.Placed];
export function canCreateOrderLine(orderStatus: OrderStatus): boolean {
  return CREATE_LINE_STATUSES.includes(orderStatus as any);
}
